(function () {
  'use strict';

  angular
    .module('FeatureOuModule', ['alert-message'])
    .factory('FeatureOuService', ['Restangular', 'AlertMessage', '$q', '$window', FeatureOuService]);

  function FeatureOuService(Restangular, AlertMessage, $q, $window) {
    let inMemoryPromiseCache = {};
    const LOCAL_STORAGE_KEY = 'featureOuConfig';
    const CACHE_EXPIRATION_MS = 60 * 60 * 1000;

    const service = {
      getFeatureOuConfig,
      getDecoratedVideoPlayerConfig,
      getDeviceScreenConfig,
      getEventsConfig,
      getVehicleRegistrationConfig,
      getVehicleTableConfig,
      getLastVisitedPageReload,
      getTrimbleLogo,
      getProductName,
      getWhatsNewConfig,
      handleError,
      clearCache
    };

    return service;

    function getFeatureOuConfig(ouId) {
      if (!ouId) {
        return $q.reject(new Error('FeatureOuService: ouId cannot be null or undefined.'));
      }

      if (inMemoryPromiseCache[ouId]) {
        return inMemoryPromiseCache[ouId];
      }

      const cachedData = getFromLocalStorage(ouId);
      if (cachedData) {
        const resolvedPromise = $q.resolve(cachedData);
        inMemoryPromiseCache[ouId] = resolvedPromise;
        return resolvedPromise;
      }

      const requestPromise = Restangular.one(`configuracao/configuracoes/${ouId}/feature-ou`).get()
        .then((featureOu) => {
          const configData = featureOu.plain();
          saveToLocalStorage(ouId, configData);
          return configData;
        })
        .catch((error) => {
          delete inMemoryPromiseCache[ouId];
          return handleError(error);
        });

      inMemoryPromiseCache[ouId] = requestPromise;

      return requestPromise;
    }

    function saveToLocalStorage(ouId, data) {
      try {
        const allConfigs = angular.fromJson($window.localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
        allConfigs[ouId] = {
          timestamp: new Date().getTime(),
          data: data
        };
        $window.localStorage.setItem(LOCAL_STORAGE_KEY, angular.toJson(allConfigs));
      } catch (e) {
        console.error('FeatureOuService: Failed to save localStorage.', e);
      }
    }

    function isCacheItemValid(item) {
      if (!item || !item.timestamp) {
        return false;
      }
      const now = new Date().getTime();
      return (now - item.timestamp) <= CACHE_EXPIRATION_MS;
    }

    function getFromLocalStorage(ouId) {
      try {
        const allConfigs = angular.fromJson($window.localStorage.getItem(LOCAL_STORAGE_KEY));
        const item = allConfigs ? allConfigs[ouId] : null;

        if (isCacheItemValid(item)) {
          return item.data;
        }

        if (allConfigs && allConfigs[ouId]) {
          delete allConfigs[ouId];
          $window.localStorage.setItem(LOCAL_STORAGE_KEY, angular.toJson(allConfigs));
        }

        return null;
      } catch (e) {
        console.error('FeatureOuService: Failed to read from localStorage.', e);
        return null;
      }
    }

    function getDecoratedVideoPlayerConfig(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.decoratedVideoPlayer);
    }

    function getDeviceScreenConfig(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.deviceScreen);
    }

    function getEventsConfig(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.events);
    }

    function getVehicleRegistrationConfig(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.vehicleRegistration);
    }

    function getVehicleTableConfig(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.vehicleTable);
    }

    function getLastVisitedPageReload(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.lastVisitedPageReload);
    }

    function getTrimbleLogo(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.trimbleLogo);
    }

    function getProductName(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.vi20ProductName);
    }

    function getWhatsNewConfig(ouId) {
      return getFeatureOuConfig(ouId).then((featureOu) => featureOu.whatsNew);
    }

    function handleError(error) {
      AlertMessage.create({
        type: 'error',
        message: 'An error occurred while loading the settings: ' + error.data.message,
        appendTo: '.alerta-aqui-geral'
      });
      return $q.reject(error);
    }

    function clearCache() {
      inMemoryPromiseCache = {};
      try {
        $window.localStorage.removeItem(LOCAL_STORAGE_KEY);
      } catch (e) {
        console.error('FeatureOuService: Failed to clean up localStorage.', e);
      }
    }
  }
})();
